// extracted by mini-css-extract-plugin
export default {"table":"ServerTable_table__gI6cO"};